import React, { useEffect, useState } from 'react'
import { Subheader } from '../../../components/Page/logix2020/Subheader'
import SubheaderTitle from '../../../components/Page/logix2020/SubheaderTitle'
import { useLocation } from 'react-router-dom'
import AssetGroupGeneralForm from '../../../components/Configuration/AssetGroups/AssetGroupGeneralForm'
import AssetGroupAddressesForm from '../../../components/Configuration/AssetGroups/AssetGroupAddressesForm'
import { useParams } from 'react-router-dom'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { StyledOfficeComponents } from '../../../components/Configuration/Office/officeHelper'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { SidebarLeft } from '../../../components/Page/logix2020/SidebarLeft'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import { useTranslation } from 'react-i18next'
import i18n from '../../../translation/i18n'
import SidebarNavigation from '../../../components/Page/logix2020/SidebarNavigation'
import { getLanguageValue } from '../../../utils/getLanguageValue'

const navigationLeft = () => [
  {
    key: 'general',
    to: '#general',
    name: i18n.t('costCenterAdmin:general'),
    disabled: false,
  },
  {
    key: 'addresses',
    to: '#addresses',
    name: i18n.t('costCenterAdmin:addresses'),
    disabled: false,
  },
]

const EditAssetGroupPage = ({ showrecursivly }) => {
  const { t } = useTranslation()
  let currentLocation = useLocation()
  const [activeNav, setActiveNav] = useState('')
  const { assetGroupId } = useParams()
  const [groupDetails, setGroupDetails] = useState('')

  useEffect(() => {
    setActiveNav(currentLocation.hash.replace('#', '') || 'general')
  }, [currentLocation.hash])

  useEffect(() => {
    apiClient
      .getJson(APIEndpoints.assetGroupAdmin(assetGroupId).group)
      .then((response) => {
        setGroupDetails(response)
      })
      .catch((error) => console.log(error))
  }, [assetGroupId])

  if (groupDetails === '') {
    return null
  }
  return (
    <>
      <Subheader className='subHeader-v1'>
        <SubheaderTitle
          withBackButton
          smallTitle={getLanguageValue(groupDetails.name.values)}
          goBackLabel={t('assetGroups:assetGroupsOverview')}
          defaultBackTo='/assetGroupsAdministration'
        />
      </Subheader>
      <FlexWrapper>
        <SidebarLeft>
          <SidebarNavigation options={navigationLeft()} active={activeNav} />
        </SidebarLeft>
        <ContentArea>
          <StyledOfficeComponents>
            {activeNav === 'general' && (
              <AssetGroupGeneralForm mode='edit' groupDetails={groupDetails} />
            )}
            {activeNav === 'addresses' && (
              <AssetGroupAddressesForm groupDetails={groupDetails} />
            )}
          </StyledOfficeComponents>
        </ContentArea>
      </FlexWrapper>
      <BigFooter />
    </>
  )
}

export default EditAssetGroupPage
